<template>


<section class="kc-elm kc-css-665494 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-794955 kc_col-sm-6 kc_column kc_col-sm-6">
            <div class="kc-col-container"></div>
         </div>
         <div class="kc-elm kc-css-511121 kc_col-sm-6 kc_column kc_col-sm-6">
            <div class="kc-col-container">
               <div class="bgrlabel  kc-elm kc-css-595041" style="left:-635px;bottom:-27px;">
                  <div class="inside_wrap">
                     <div class="imgl">
                        <img 
                           class=" ls-is-cached lazyloaded wow animated bounceInLeft" 
                           data-wow-duration="2s" data-wow-delay="0s" 
                           :data-src="'@/assets/images/' + image" alt="" 
                           :src="require('@/assets/images/' + image)"
                           :style="'max-width:100%;width:' + width"
                        ></div>
                  </div>
               </div>
               <div class="ssc_mltttl  kc-elm kc-css-553400 ">
                  <div class="wr deb derb dea dera none nonea">
                     <slot name="title">
                        <h2 class="t1">We Are </h2>
                        <h2 class="t2">Professional</h2>
                        <h2 class="t3"> Digital Team</h2>
                     </slot>
                     <slot name="subtitle">
                        <p class="t4">Our web design company specializes in the professional creation of unique sites.</p>
                     </slot>
                  </div>
               </div>
               <div class="kc-elm kc-css-194884 kc_text_block">
                  <slot name="description">
                     <p>Our team constantly monitors the emergence of new technologies that we are not afraid to implement in web projects. We create only selling websites – this is an achievement by drawing the design and working out usability. The approach to each new project is individual, we treat every customer equally, regardless of the size of the company and its budget.</p>
                  </slot>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
export default {
  name: "TextImgLeft",
  props: ["title", "subtitle", "header", "image", "width"],
  data() {
    return {
      msg: "TextImgLeft"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-6{width:50%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_column{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container{height:100%;}
.kingcomposer div.kc_column{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
.kc_text_block{display:inline-block;clear:both;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column{width:100%;}
}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus{outline:none;}
section{display:block;}
img{border:0;border-radius: 50%;max-width:100%;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
*,*:before,*:after{box-sizing:inherit;}
img{height:auto;max-width:75%;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
.kc-col-container>div.bgrlabel{z-index:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
body .bgrlabel{float:none;position:absolute;display:inline-block;width:auto;}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
.ssc_mltttl .wr p{margin:0;}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
p.t4{font-size:20px;line-height:26px;padding-top:20px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-794955{width:49%;}
body.kc-css-system .kc-css-511121{width:51%;}
}
body.kc-css-system .kc-css-665494{padding-top:40px;padding-bottom:0px;}
body.kc-css-system .kc-css-511121{padding-top:60px;}
body.kc-css-system .kc-css-553400.ssc_mltttl .wr{text-align:left;}
body.kc-css-system .kc-css-553400{text-align:center;padding-bottom:5px;display:inline-block;}
body.kc-css-system .kc-css-553400 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-553400 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-553400 .t1{text-align:left;text-transform:full-size-kana;line-height:39px;display:inline;}
body.kc-css-system .kc-css-553400 .t2{color:#ED7D31;text-align:left;line-height:39px;display:inline;}
body.kc-css-system .kc-css-553400 .t3{text-align:left;line-height:39px;margin-top:5px;}
body.kc-css-system .kc-css-553400 .t4{font-size:22px;line-height:30px;padding-top:20px;display:block;}
body.kc-css-system .kc-css-194884{padding-top:5px;padding-right:3%;}
body.kc-css-system .kc-css-194884 p{margin-bottom:15px;}
@media only screen and (max-width:768px){
body.kc-css-system .kc-css-553400 .deb:before{display:none;}
body.kc-css-system .kc-css-553400 .deb:after{display:none;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-794955{padding-right:0px;}
body.kc-css-system .kc-css-511121{padding-right:0px;}
body.kc-css-system .kc-css-511121{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-366355{display:none;}
body.kc-css-system .kc-css-595041{display:none;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-665494{padding-top:80px;padding-bottom:0px;}
body.kc-css-system .kc-css-553400{padding-right:15px;}
body.kc-css-system .kc-css-553400 .t3{margin-top:0px;}
body.kc-css-system .kc-css-553400 .t4{padding-right:0px;}
body.kc-css-system .kc-css-194884{padding-right:15px;}
}

</style>



// WEBPACK FOOTER //
// src/components/Blocks/TextImgLeft.vue